import React from 'react';

export default React.createContext({
  name: 'root',
  fields: [],
  getOperators: () => [],
  onSubmit: () => {}
});
